import React from "react";

const ProgramContext = React.createContext("program");

export default ProgramContext;

//initial context data
let ProgramSettings = {
  managerView: false,
  userId: null,
};

export { ProgramSettings };
